<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M4.41,8C4.41,8,7.7,4.71,7.7,4.71C7.89,4.53,8,4.28,8,4C8,3.45,7.55,3,7,3C6.72,3,6.47,3.11,6.29,3.29C6.29,3.29,2.29,7.29,2.29,7.29C2.11,7.47,2,7.72,2,8C2,8.280000000000001,2.11,8.530000000000001,2.29,8.71C2.29,8.71,6.29,12.71,6.29,12.71C6.47,12.89,6.72,13,7,13C7.55,13,8,12.55,8,12C8,11.72,7.89,11.47,7.71,11.29C7.71,11.29,4.41,8,4.41,8C4.41,8,4.41,8,4.41,8ZM9.41,8C9.41,8,12.7,4.71,12.7,4.71C12.89,4.53,13,4.28,13,4C13,3.45,12.55,3,12,3C11.72,3,11.47,3.11,11.29,3.29C11.29,3.29,7.29,7.29,7.29,7.29C7.11,7.47,7,7.72,7,8C7,8.280000000000001,7.11,8.530000000000001,7.29,8.71C7.29,8.71,11.29,12.71,11.29,12.71C11.47,12.89,11.72,13,12,13C12.55,13,13,12.55,13,12C13,11.72,12.89,11.47,12.71,11.29C12.71,11.29,9.41,8,9.41,8C9.41,8,9.41,8,9.41,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DoubleChevronLeft',
} as DefineComponent
</script>
